import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import { type DetailedChangeset } from 'ember-changeset/types';
import PowerSelect from 'ember-power-select/components/power-select';
import type EmployeeModel from 'garaje/models/employee';
import type SignInFieldModel from 'garaje/models/sign-in-field';
import { empty, not, and } from 'macro-decorators';

interface EntriesHostFieldSignature {
  Args: {
    allowClear?: boolean;
    changeset: DetailedChangeset<SignInFieldModel> | SignInFieldModel;
    disabled?: boolean;
    errors?: string[] | string;
    label: string;
    required?: boolean;
    selected: EmployeeModel | null;
    search: (term: string) => Promise<EmployeeModel[]>;
    update: (model: DetailedChangeset<SignInFieldModel> | SignInFieldModel, selected: EmployeeModel) => unknown;
    validated?: boolean;
  };
  Element: HTMLDivElement;
}

export default class EntriesHostField extends Component<EntriesHostFieldSignature> {
  placeholder = 'Choose a Host';

  @empty('args.errors') declare hasNoErrors: boolean;
  @not('hasNoErrors') declare hasErrors: boolean;
  @and('args.validated', 'hasErrors') declare isDisplayingErrors: boolean;

  <template>
    <div data-test-flow-field={{@changeset.name}} data-test-custom-field={{@changeset.name}} ...attributes>
      <label
        data-test-select-label
        for={{@changeset.id}}
        class="{{if this.isDisplayingErrors 'error-description'}} {{if @disabled 'cursor-default'}}"
      >
        {{@label}}
        {{#if @required}}
          <span class="requiredField"></span>
        {{/if}}
      </label>
      <div style="margin-bottom:20px;" class="w-full" data-test-option-select>
        <PowerSelect
          @allowClear={{@allowClear}}
          @placeholder={{this.placeholder}}
          @selected={{@selected}}
          @disabled={{@disabled}}
          @triggerClass={{if this.isDisplayingErrors "power-select-error"}}
          @search={{@search}}
          @searchEnabled={{true}}
          @onChange={{fn @update @changeset}}
          as |employee|
        >
          {{employee.name}}
        </PowerSelect>
      </div>
      {{#if this.isDisplayingErrors}}
        <div data-test-input-error class="bottom-error">This is a required field</div>
      {{/if}}
    </div>
  </template>
}
